import { render, staticRenderFns } from "./DefaultContent-Product.vue?vue&type=template&id=10df7542&scoped=true&"
import script from "./DefaultContent-Product.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Product.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContent-Product.vue?vue&type=style&index=0&id=10df7542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df7542",
  null
  
)

export default component.exports